export default "__VITE_ASSET__B$Kse$0r__"